import * as React from "react";
import { StaticImageData } from "next/image";

import { getFormattedDate } from "@stadium/helpers/dayjs";
import Multimedia from "@stadium/shared/src/components/shared/multimedia";

import { HERO_DEFAULTS, H_03 } from "@stadium/shared/src/helpers/plasmic/static-slices";

import styles from "./main.module.scss";

export interface H03Props {
  // Hero Content
  heading?: string;
  description?: string;

  // Team Info
  teamTitle?: string;
  teamDate?: string;
  teamDateFormat?: string;

  // Badge
  badgeLogo?: string | StaticImageData;
  badgeLogoAlt?: string;

  // Hero Image
  heroImage: string | StaticImageData;
  heroImageAlt?: string;

  className?: string;
}

const H03: React.FC<Readonly<H03Props>> = ({
  heading = HERO_DEFAULTS[H_03].heading,
  description = HERO_DEFAULTS[H_03].description,
  teamTitle = HERO_DEFAULTS[H_03].teamTitle,
  teamDate,
  teamDateFormat = "Do MMM YYYY",
  badgeLogo = HERO_DEFAULTS[H_03].badgeLogo,
  badgeLogoAlt = HERO_DEFAULTS[H_03].badgeLogoAlt,
  heroImage = HERO_DEFAULTS[H_03].heroImage,
  heroImageAlt = HERO_DEFAULTS[H_03].heroImageAlt,
  className,
}) => {
  const formattedDate = getFormattedDate(teamDate || new Date().toISOString(), teamDateFormat);
  return (
    <section className={`${styles.sectionWrapper} ${className || ""}`}>
      {/* Main Hero Section */}
      <div className={styles.h03Container}>
        <div className={styles.heroContent}>
          {/* Left Content */}
          <div className={styles.leftContent}>
            {/* Text Content */}
            <div className={styles.textContent}>
              <h1 className={styles.heading}>{heading}</h1>
              <p className={styles.description}>{description}</p>
            </div>
            <div className={styles.teamWrapper}>
              <div className={styles.badgeLogo}>
                <Multimedia
                  type="image"
                  src={badgeLogo}
                  alt={badgeLogoAlt}
                  className={styles.badgeLogoImage}
                />
              </div>
              <div>
                <h1 className={styles.teamTitle}>{teamTitle}</h1>
                <p className={styles.teamDate}>{formattedDate}</p>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className={styles.rightImage}>
            <Multimedia
              type="image"
              src={heroImage}
              alt={heroImageAlt}
              className={styles.h07Image}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
export default H03;
